import {
  FaUsers,
  FaFilter,
  FaUser,
  FaTools,
  FaCog,
  FaPlayCircle,
} from "react-icons/fa";
import { SiAdguard } from "react-icons/si";
import { BsFilePlusFill, BsFillGridFill } from "react-icons/bs";
import { HiDocumentText } from "react-icons/hi2";
import { AiFillInfoCircle } from "react-icons/ai";

interface ISidebarMenuModel {
  label: string;
  menus: {
    menu: string;
    url: string;
    icon: any;
  }[];
}

export const SidebarMenu: ISidebarMenuModel[] = [
  {
    label: "Workforce",
    menus: [
      {
        menu: "Teams",
        url: "/teams",
        icon: <FaUsers />,
      },
      {
        menu: "Agents",
        url: "/agents",
        icon: <FaUser />,
      },
      {
        menu: "Knowledge",
        url: "/knowledge",
        icon: <FaFilter />,
      },
      {
        menu: "Guardrails",
        url: "/guardrails",
        icon: <SiAdguard />,
      },
      {
        menu: "Tools",
        url: "/tools",
        icon: <FaTools />,
      },
    ],
  },
  {
    label: "Customization",
    menus: [
      {
        menu: "Templates",
        url: "/templates",
        icon: <BsFillGridFill />,
      },
      {
        menu: "Integration",
        url: "/integration",
        icon: <BsFilePlusFill />,
      },
      {
        menu: "Settings",
        url: "/settings",
        icon: <FaCog />,
      },
    ],
  },
  {
    label: "Support",
    menus: [
      {
        menu: "Tutorials",
        url: "/tutorials",
        icon: <FaPlayCircle />,
      },
      {
        menu: "Documentation",
        url: "/documentation",
        icon: <HiDocumentText />,
      },
      {
        menu: "Community",
        url: "/community",
        icon: <FaUsers />,
      },
      {
        menu: "Help",
        url: "/help",
        icon: <AiFillInfoCircle />,
      },
    ],
  },
];
